module.exports = __webpack_public_path__ + "static/media/connect-icon.d05976d3.svg";